import { stateKeys } from './constants';

export const selectDate = (state) => state[stateKeys.date];
